import _ from 'lodash';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { first } from 'rxjs/operators';
import { finalizeVirtualEventAuctionItem, removeVirtualEventAuctionBid } from 'app/virtual-event/features/data/data.actions';
import { selectVirtualEventData } from 'app/virtual-event/features/data/data.selectors';
import { CampaignOptionLeaderModel } from '../../models/campaign-option-leader.model';
import { openDialog } from 'app/dialog/features/dialog.actions';
import { SharedService } from '../../services/shared.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-currently-live-auction',
  templateUrl: './currently-live-auction.component.html',
  styleUrls: ['./currently-live-auction.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CurrentlyLiveAuctionComponent implements OnChanges {
  destroyRef = inject(DestroyRef)
  @Input() campaign: any = null;
  @Input() option: any = null;
  @Input() type: any = 'dark';

  public count: number = null;
  public soldCount: number = null;
  public available: number = null;
  public leader: CampaignOptionLeaderModel = null;

  public buttonLabel: string = 'Declare Winner';
  public buttonDeclareWinnerDisabled: boolean = false;
  public buttonSellMoreDisabled: boolean = false;

  constructor(
    public store: Store,
    public sharedService: SharedService
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    const option = _.get(changes, 'option.currentValue', this.option);
    const count = _.get(option, 'count', 0);
    const soldCount = _.get(option, 'soldCount', 0);
    const bids = _.get(option, 'currentBids', []) || [];

    this.leader = bids.length > 0 ? new CampaignOptionLeaderModel(bids[0]): null;
    if(this.leader) {
      this.leader.isWinner = soldCount > 0;
    }

    this.count = count;
    this.soldCount = soldCount;
    this.available = count - soldCount;
    this.buttonLabel = _.get(this.leader, 'data.winningBid', false) ? 'Declared': 'Declare Winner';
    this.buttonDeclareWinnerDisabled = _.get(this.leader, 'data.winningBid', true) || this.available === 0;
    this.buttonSellMoreDisabled = this.available < 1;
  }

  removeBid(bidId) {
    const { campaign, option } = this;
    return this.store.dispatch({
      type: removeVirtualEventAuctionBid.type,
      payload: {
        eventId: this.sharedService.id,
        campaign,
        option,
        bidId
      }
    });
  }

  getImageUrl() {
    const { option } = this;
    return _.get(option, 'imageUrl', '') === '' ? '/images/blank-image.png': option.imageUrl;
  }

  finalizeAuctionItem(campaign, option) {
    return this.store.pipe(
      select(selectVirtualEventData),
      first(),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(data => {
      return this.store.dispatch({
        type: finalizeVirtualEventAuctionItem.type,
        payload: {
          vEventId: data.id,
          campaignId: campaign.id,
          option: option
        }
      });
    })
  }

  showLiveAuctionMulti(campaign, option) {
    return this.store.pipe(
      select(selectVirtualEventData),
      first(), 
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(data => {
      return this.store.dispatch({
        type: openDialog.type,
        payload: {
          name: 'showLiveAuctionMulti',
          options: {
            size: 'small',
            modalClass:'modal--paybee modal-sm',
            containerClass:'mdb-modal-backdrop-paybee',
            ignoreBackdropClick: true
          },
          initialState: {
            eventId: data.id,
            campaignId: campaign.id,
            option: option,
            amount: 900
          }
        }
      });
    })
  }

  getCurrentBid() {
    const bids = _.get(this.option, 'currentBids', []) || [];
    const maxBid = _.maxBy(bids, function(bid) { return bid.amount; });
    return _.get(maxBid, 'amount', 0);
  }

}
